import cleanedFilename from '~/util/cleanedFilename';

export default {
  ERROR_MESSAGE: `${cleanedFilename(__filename)}-error-message`,
  LIST_ITEM: `${cleanedFilename(__filename)}-list-item`,
  EMPTY_STATE: `${cleanedFilename(__filename)}-empty-state`,
};
